import {useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import AiIterDlg from '@/pages/MainPage/panes/PrjPatternDetail/AiIterDlg.jsx'

export const canAiGenerateUptIter = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === this.data.prjId &&
                /^(BD|DT|FM|UI)$/.test(bizNodeType)
            )
        })
    }
}

export const aiGenerateUptIter = () => () => {
    const openModal = useOpenModal()

    return async function (nodes) {
        const ns = this.commands.canAiGenerateSrf(nodes)
        const {prjId, prjPatternId, sVer} = this.data
        const fmIds = []
        const modules = []

        for (const n of ns) {
            const {bdName, bizNodeType, dtName, pkid, uiName} = n.data

            if ('FM' === bizNodeType) {
                fmIds.push(pkid)
            }
            else {
                modules.push({
                    moduleId: pkid,
                    moduleName: bdName ?? dtName ?? uiName,
                    moduleType: bizNodeType,
                })
            }
        }

        const param = {fmIds, modules, prjPatternId, prjId, sVer}
        const result = await openModal(<AiIterDlg param={param} />)

        if (! result) {
            return
        }

        const {
            bdIds,
            dpSn: srfNo,
            files,
            pkid: srfId,
            reqDesc,
            uiIds,
            dtIds,
        } = result

        const prjs = [{patternId: prjPatternId}]

        openWindow(
            '/Ai',

            {
                bizMap: {bdIds, prjs, srfId, srfNo, uiIds, dtIds},
                prjId,
                scene: 'GENERATE_UPT_ITER',
                sVer,
                defaultDraft: JSON.stringify({content: reqDesc, files}),
            }
        )
    }
}
